import React from 'react';
import { Dashboard as DashboardLayout } from '../../layouts';
import { TabsURL } from '../../helpers/enums';
import TabPermissions from '../../components/TabPermissions/TabPermissions';
import { Parceiros } from './components/Parceiros/Parceiros';
import { Clientes } from './components/Clientes/Clientes';
import { Campanhas } from './components/Campanhas/Campanhas';
import { CommunityErrors } from './components/Errors/Errors';
import { BeneficiosMGM } from './components/BeneficiosMGM/BeneficiosMGM';
import RegraDesconto from './components/RegraDesconto/RegraDesconto';
import { ContestComission } from './components/ContestComission/ContestComission';
import { ListagemPlanos } from './components/ListagemPlanos/ListagemPlanos';
import { Pendencias } from './components/Pendencias/Pendencias';

export const tabsComunidade = Object.freeze({
  [TabsURL.COMUNIDADE__PARCEIROS]: {
    component: <Parceiros />,
    label: 'FECHAMENTO DE CICLO',
  },
  [TabsURL.COMUNIDADE__CLIENTES]: {
    component: <Clientes />,
    label: 'CLIENTES',
  },
  [TabsURL.COMUNIDADE__CAMPANHAS]: {
    component: <Campanhas />,
    label: 'CAMPANHAS',
  },
  [TabsURL.COMUNIDADE__BENEFITS_MGM_ERRORS]: {
    component: <CommunityErrors />,
    label: 'LOGS DE BENEFÍCIO MGM',
  },
  [TabsURL.COMUNIDADE__MGM]: {
    component: <BeneficiosMGM />,
    label: 'BENEFICIOS MGM',
  },
  [TabsURL.COMUNIDADE__REGRAS_DESCONTOS]: {
    component: <RegraDesconto />,
    label: 'REGRAS DESCONTOS',
  },
  [TabsURL.COMUNIDADE__CONTEST_COMISSION]: {
    component: <ContestComission />,
    label: 'CONTESTAÇÕES',
  },
  [TabsURL.COMUNIDADE__LISTAGEM_PLANOS]: {
    component: <ListagemPlanos />,
    label: 'LISTAGEM PLANOS',
  },
  [TabsURL.COMUNIDADE__PENDENCIAS]: {
    component: <Pendencias />,
    label: 'PENDÊNCIAS',
  },
});

export default function Comunidade() {
  return (
    <DashboardLayout title="Comunidade">
      <TabPermissions tabs={tabsComunidade} />
    </DashboardLayout>
  );
}
